import { UploadOutlined } from "@ant-design/icons";
import { Button, Divider, Upload } from "antd";
import useUploadFile from "../../hooks/useUploadFile";

const UploadFile = ({ file }) => {
    const { id, name, maxFiles, fileList: initialFileList } = file;

    const { fileList, handleChange, handleUploadFile } = useUploadFile(
        name,
        initialFileList
    );

    const title = `${id} - ${name}`;

    return (
        <>
            <h4>{title}</h4>
            <Upload
                // listType='picture-card'
                customRequest={handleUploadFile}
                onChange={handleChange}
                fileList={fileList}
                maxCount={maxFiles}
            >
                {fileList.length === maxFiles ? null : (
                    <Button icon={<UploadOutlined />}>Cargar Archivo </Button>
                )}
            </Upload>
            <Divider />
        </>
    );
};

export default UploadFile;
